import { isEmpty } from 'lodash';
import { MISSION_EXPERTISE_VICTIM_TYPE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';

export const renderPathApiByPayload = (payload: any) => {
  if (payload.isIntervenant && !payload.claimId) {
    if (payload.missionVehicleId) {
      return `/corporeal/common/mission-expertise?missionId=${payload.missionId}&missionVehicleId=${payload.missionVehicleId}`;
    } else {
      return `/corporeal/common/mission-expertise?missionId=${payload.missionId}&missionVictimId=${payload.missionVictimId}`;
    }
  } else {
    return `/corporeal/common/mission-expertise?missionId=${payload.missionId}&missionVictimId=${payload.missionVictimId}&missionVehicleId=${payload.missionVehicleId}&claimId=${payload.claimId}`;
  }
};

export const filterExpertiseVictim = (
  expertiseVictim: any,
  expertCode: any,
) => {
  if (!isEmpty(expertiseVictim)) {
    const filtredRapport = expertiseVictim.filter(
      (el: any) => el.createdBy === expertCode,
    );
    if (
      !isEmpty(
        filtredRapport.find(
          (el: any) => el.type === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION,
        ),
      )
    ) {
      return expertiseVictim;
    } else {
      return expertiseVictim.filter(
        (item: any) => item.type != MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION,
      );
    }
  } else {
    return expertiseVictim;
  }
};
